module.exports = __webpack_public_path__ + "static/media/strawberry_256x256-collected.f1ed1860.png";